module.exports = __webpack_public_path__ + "img/goods_bg.0b40afbe.jpg";